export const environment = {
  name: 'staging',
  production: false,
  apiBaseUrl: 'https://saferwise-uat-api.stageserver.live/coreapi/',
  nodeApiUrl: 'https://saferwise-uat-api.stageserver.live/node/',
  //googleMapsApiKey: 'AIzaSyBY6spxPMf0AL3seftvLRs_LJVxCGR3QX8' // Rep old key
  googleMapsApiKey: 'AIzaSyD0qGSqTCeOaQ3y9o-2P05aVGX2wx1yyQk' // Rep
};

